import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-finish',
  standalone: true,
  imports: [],
  templateUrl: './finish.component.html',
  styleUrl: './finish.component.scss'
})
export class FinishComponent {
  @Input() active!: boolean;
  @Output() clicked = new EventEmitter<void>();

  onClick(event: Event): void {
    event.stopPropagation();
    if (this.active) {
      this.clicked.emit();
    }
  }
}
